import { Component, Inject, OnInit } from '@angular/core';
import { ADD_CARRIERS_TO_PROJECT_OPTIONS } from './constants';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { IS_NULL_OR_UNDEFINED, RestService } from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

@Component({
	selector: 'app-add-carriers-dialog',
	templateUrl: './add-carriers-dialog.component.html',
})
export class AddCarriersDialogComponent implements OnInit {
	isRequestInProgress: boolean = false;
	ADD_CARRIERS_TO_PROJECT_OPTIONS = ADD_CARRIERS_TO_PROJECT_OPTIONS;
	IS_NULL_OR_UNDEFINED = IS_NULL_OR_UNDEFINED;
	procureCarriersChoice = null;

	constructor(
		public dialogRef: MatDialogRef<AddCarriersDialogComponent>,
		private urlService: UrlService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private restService: RestService,
		private utilService: UtilService
	) {}

	ngOnInit() {}

	selectOption() {
		this.isRequestInProgress = true;
		const url = this.urlService.procureCarriersFromScorecard();
		const payload = {
			...this.data,
			procureCarriersChoice: this.procureCarriersChoice,
		};
		this.restService.POST(url, payload).subscribe({
			next: (result) => {
				const message = result.data;
				this.utilService.showSnackbar(message, SNACKBAR.SUCCESS, SNACKBAR.ACTION);
				this.dialogRef.close();
			},
			error: () => {
				this.utilService.showSnackbar(
					'Could not add carriers. Please try adding carriers from Recommended tab.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
			},
		});
	}

	closeDialog(): void {
		this.dialogRef.close();
	}
}
